











import Vue from 'vue';
import { AsyncBtn } from 'mycorems-app-shared';
import isGranted from '../../auth/isGranted';
import { AccountSubscriber } from '../../types';
import { subscribe } from '.';

interface Data {
  task: Promise<AccountSubscriber>|null,
}

export default Vue.extend({
  components: { AsyncBtn },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'far fa-bell',
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    subscribe() {
      this.task = subscribe(this.accountId, this.userId);
      this.task.then((subscriber: AccountSubscriber) => {
        this.$emit('subscribed', subscriber);
      });
    },
    isGranted,
  },
});
